<template>
    <div>
        <PageTitle :title="$t('afiliados.titulo')" sectionClass="strech" />
        <section class="padding-vertical-content white-content right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style="{ backgroundImage: 'url(' + require('@/assets/images/afiliados-imagen.png') + ')'}">
            </div>
            <b-container>
                <b-row class="justify-content-start">
                    <b-col sm="12" lg="5">
                        <h2 style="font-size: 30px;" class="mt-3 text-uppercase">{{ $t('afiliados.info') }}</h2>
                        <h3 style="font-size: 25px;" class="subtitle light mb-4"> {{ $t('afiliados.evento') }}</h3>

                        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                            <FormInput
                                :label="$t('formularios.numero_afiliado')"
                                :name="$t('formularios.numero_afiliado')"
                                rules="required"
                                v-model="numeroAfiliado"
                            />
                            
                            <span v-if="error" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 mt-0 p-2 font-weight-bold">
                                {{ error }}
                            </span>
                            <button 
                                id="buscar-afiliado"
                                type="submit" 
                                :class="['mt-0', 'mt-md-2', 'button', 'effect-button', { 'large-button': !esMovil }]" 
                                :disabled="loading"
                            >
                                <span>{{ $t('afiliados.buscar') }}</span>
                            </button>
                        </ValidationObserver>
                    </b-col>
                </b-row>
            </b-container>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import {useHead} from "@/composables/common/seo/useHead";

    export default {
        data() {
            return {
                loading: false,
                numeroAfiliado: '',
                error: ''
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid) {
                    this.buscarAfiliado();
                }
            },
            buscarAfiliado() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.teatro.hash,
                        localizador: this.numeroAfiliado
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.afiliados.buscar'), params).then(res => {
                    this.$router.push(`/${res.data.url}`);
                }).catch(error => {
                    console.log(error);
                    this.error = error.response.data.message;
                }).finally(() => this.loading = false);
            },
        },
        computed: {
            manager(){
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        created() {
            if (this.manager.ocultar_afiliados) {
                this.$router.push({ name: 'front.home' });
            }
            useHead('Afiliados');
        },
        components: {
            PageTitle
        }
    }
</script>
